import { AttendRegisterFactory } from './attendRegisterFactory';

import type {
  AttendRegisterEntity,
  AttendRegisterJsonPub,
  AttendRegisterJsonPvt,
  AttendRegisterPropsPub,
  AttendRegisterPropsPvt,
} from './attendRegisterEntity';
import type { AttendRegisterIRepository } from './attendRegisterIRepository';
import type { EntityDataPubType } from '@/infra/appsync';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class AttendRegisterRepository extends AppsyncRepository<
  AttendRegisterEntity,
  AttendRegisterPropsPvt,
  AttendRegisterJsonPvt,
  AttendRegisterPropsPub,
  AttendRegisterJsonPub
> implements AttendRegisterIRepository {
  private factory = new AttendRegisterFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryAttendRegisterAttendRegisterEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
